import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import {NavigateFunction} from "react-router-dom";

import {apiRequestMemberLogin} from "../../api/apiRequests";
import {setToken} from "./RequireAuth";
import {ROUTES} from "../../helpers/constants";
import {fetchFiles} from "../member/memberFilesSlice";

export interface userState {
  userName: string,
  userEmail: string,
  loginStatus?: string,
  thumbnail?: string,
  userError?: string,
}

const initialState: userState = {
  userName: "User Name Test",
  userEmail: "",
  thumbnail: "",
  loginStatus: "",
  userError: "",
}

export const fetchLoginUser = createAsyncThunk(
  'login/post',
  async (params: {email: string, password: string, navigate: NavigateFunction}) => {
    const {email, password, navigate} = params;
    console.log("{email, password}", params);
    try {
      const loginResponse = await apiRequestMemberLogin({username: email, password});
      if (typeof loginResponse === "object") {
        if (loginResponse.token) {
          setToken(loginResponse.token);
          navigate(ROUTES.eLibrary);
        } else if (loginResponse?.response?.data?.message) {
          return {
            error: loginResponse.response.data.message
          }
        }
      }
      console.log("loginResponse", loginResponse);
    } catch (error) {
      console.log("error", error);
      if ((typeof error === "object") && error?.response?.data?.message) {
      // && error.response.status === 401
        return {
          error: error.response.data.message
        }
      }
    }
    return null
  },
)

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    // increment: (state) => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
    setUser: (state, action: {payload: {userName: string}}) => {
      console.log("state", state);
      console.log("action", action);
      state.userName = action.payload.userName;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLoginUser.pending, (state) => {
        state.loginStatus = "loading"
      })
      .addCase(fetchLoginUser.fulfilled, (state, action:PayloadAction<{error: string}>) => {
        state.loginStatus = "succeeded";
        if (action?.payload?.error) {
          state.userError = action.payload.error;
        } else {
          state.userError = "";
        }
      })
      .addCase(fetchLoginUser.rejected, (state) => {
        state.loginStatus = "failed"
      })
      .addCase(fetchFiles.fulfilled, (
        state,
        action:PayloadAction<{member: {name: string, email: string}}>
      ) => {
        if (action?.payload?.member?.name) {
          state.userName = action.payload.member.name;
        }
        if (action?.payload?.member?.email) {
          state.userEmail = action.payload.member.email;
        }
      })
  },
});

export const { setUser } = loginSlice.actions;

export default loginSlice.reducer